@if (row.isMainCropAid && columnOrderPlanPeriod) {
  <div [class.text-negative]="columnOrderPlanPeriod.orderLinesTotalAmount < columnOrderPlanPeriod.requisiteAmount">
    <span matTooltip="{{ 'quantityOrdered' | translate }}" matTooltipPosition="left" class="text--bold">
      {{ columnOrderPlanPeriod.orderLinesTotalAmount }}{{ row.unitOfMeasurement }} </span
    >/<span matTooltip="{{ 'advisedQuantity' | translate }}" matTooltipPosition="left"
      >{{ columnOrderPlanPeriod.requisiteAmount | number: '1.0-2' }}{{ row.unitOfMeasurement }}</span
    >
  </div>
}
@if (!row.isMainCropAid && columnOrderPlanPeriod) {
  <mat-form-field
    class="orderplan__input mat-form-field__no-spacing spacing--margin-half-vertical"
    [ngClass]="{
      'border-yellow': isOrderLineNotOptimized() && (orderplanOptimized$ | async) && columnOrderPlanPeriod?.packageCount,
      'border-open': shouldShowOpenBorder(),
      'border-incart': shouldShowInCartBorder(),
      'border-ordered': shouldShowOrderedBorder(),
    }"
    [matTooltip]="!productHasPackages ? ('noPackages' | translate) : null"
    subscriptSizing="dynamic"
  >
    <input
      matInput
      id="input-with-cursor"
      class="orderplan__input-text"
      type="number"
      [disabled]="columnOrderPlanPeriod?.isDisabled || !productHasPackages || !orderLineOpened"
      [(ngModel)]="columnOrderPlanPeriod.packageCount"
      [min]="getNotOpenCount()"
      (blur)="editOrderLine()"
      data-test="package-count-input"
    />
    <div
      matSuffix
      [ngClass]="{
        'icon-container': !bothIconsVisible(),
        'double-icon-container': bothIconsVisible(),
      }"
      matTooltipClass="suffix-tooltip"
      [matTooltip]="getToolTipText()"
      class="spacing--padding-none-all"
    >
      @if (optimizationIconVisible()) {
        <mat-icon
          [ngClass]="{ disabled: columnOrderPlanPeriod?.isDisabled || !orderLineOpened }"
          matListIcon
          data-test="optimizer-icon"
          class="input-suffix-icon"
          >square_foot</mat-icon
        >
      }
      @if (infoIconVisible()) {
        <mat-icon [ngClass]="{ disabled: columnOrderPlanPeriod?.isDisabled || !orderLineOpened }" matListIcon data-test="info-icon" class="input-suffix-icon"
          >info_outline</mat-icon
        >
      }
      @if (!infoIconVisible()) {
        <mat-icon matListIcon data-test="info-icon" class="input-suffix-icon hidden">info_outline</mat-icon>
      }
    </div>
  </mat-form-field>
}
